import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { getCustomerBanners, addImage,updateCustomerBanner} from "../../redux/actions/reseller"
import { LoaderWrapper } from "../../HOC"
import { FileUpload, ReactSelect, NormalInput,SliderOverlay} from "../../component/common"

class CustomerBannerListClass extends Component {

  state = {
    customerBannerList:[],
  }
  componentDidMount(){
    this.props.getCustomerBanners().then((data) => {
			this.setState({ customerBannerList: data })
		})
  }

  ImagePreview = (key, event,index) => {
    let files = event.target.files[0]
    let customerBannerList = Object.assign([], this.state.customerBannerList)
    let formData = new FormData()
    formData.append("resellerImage", files)
    this.props.addImage(formData).then((data) => {
      customerBannerList[index].image_url=data.imageUrl
      this.setState({customerBannerList: customerBannerList})
    })
  }

  handlePositionOptions =(index, { name, value }) => {
    let customerBannerList = Object.assign([], this.state.customerBannerList)
      customerBannerList[index].position = value;
      this.setState({
        customerBannerList
      })
  }

  handleSubmit() {
    let customerBannerList= this.state.customerBannerList
    
    this.props.updateCustomerBanner(customerBannerList).then((data) => {
      this.setState({
        customerBannerList:data
      })
    }).catch((ex) => {
      this.setState({disabled:false})
    })
    
  }

  handlePageUrlOptions =(index, { name, value }) => {
    let customerBannerList = Object.assign([], this.state.customerBannerList)
    customerBannerList[index].page_url = value;
      this.setState({
        customerBannerList
      })
  }

  render() {
    let tempFile = ""
    let {customerBannerList,imageTypes} = this.state
    return (
      <div className="asd">
        {/* Header */}
        <div className="sair-pg-header">
          <h4 className="sair-pg-title align-self-center">
            <span className="pg-title-icon">
              <span className="feather-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" className="feather feather-align-left">
                  <line x1="17" y1="10" x2="3" y2="10"></line>
                  <line x1="21" y1="6" x2="3" y2="6"></line>
                  <line x1="21" y1="14" x2="3" y2="14"></line>
                  <line x1="17" y1="18" x2="3" y2="18"></line>
                </svg>
              </span>
            </span>Customer Banner
          </h4>
        </div>
        {/* Content */}
        <section className="sair-sec-wrapper">
            <div>Customer Banner</div>
            <h6 className="mb-15 row">
                <div className="col-sm-6">Images</div>
                <div className="col-sm-6 text-right">
                </div>
            </h6>
            {customerBannerList && customerBannerList.length > 0 ? customerBannerList.map((item, index) => {
              let {image_url, position, page_url} = item
              return (
                <div className="row container" key={index}>
                  <div className="col-md-6 form-group">
                    <label ><b> Product Image </b> Index: {index}</label>
                    <FileUpload
                      fileUpload={this.fileUpload}
                      ImagePreview={(e) => this.ImagePreview("product image", e,index)}
                      filename={image_url}
                      tempFile={tempFile}
                    />
                    <img src={image_url} style={{ width: "200px", marginTop: "15px" }} />
                  </div>
                  <div className="col-md-3 form-group">
                    <label >Customer banner position</label>
                    <NormalInput
                        className="form-control"
                        name="position"
                        type="text"
                        value={position}
                        onChange={({ name, value }) => {
                          this.handlePositionOptions(index, { name: name, value: value })
                        }}
                        // validationError={this.validator.message('Sair mall price', name, 'required')}
                      />
                  </div>
                  <div className="col-md-3 form-group">
                    <label >Customer page url</label>
                      <NormalInput
                        className="form-control"
                        name="pageUrl"
                        type="text"
                        value={page_url}
                        onChange={({ name, value }) => {
                          this.handlePageUrlOptions(index, { name: name, value: value })
                        }}
                      />
                  </div>
                </div>
              )
            })
            :""}
        </section>
        
        <hr />
          <button className="btn btn-primary"
            onClick={() => this.handleSubmit()}
            disabled={this.state.disabled}
          >Submit</button>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    customerBannerList: state.reseller.customerBannerList // data from reducer to brandList
  }
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    getCustomerBanners,
    addImage,
    updateCustomerBanner
  }, dispatch)
};

let actions = []

let component = LoaderWrapper(CustomerBannerListClass)({ actions })

export const CustomerBannerList = connect(mapStateToProps, mapDispatchToProps)(component)
